window.addEventListener('scroll', function () {
  toggleMenuStyle();
});
window.addEventListener("load", () => {
  toggleMenuStyle();
});
function toggleMenuStyle() {
  let scrollPosition = 0;
  let template = document.querySelector('html');
  let screenHeight = screen.height - 60; // subtract 60px to display the background before the second section

  let header = document.querySelector('.header');
  scrollPosition = window.scrollY;

  // Define differents height depending on the page
  let valueToChangeHeaderStyle;
  if (template.classList.contains('template-index')) {
    if (window.matchMedia("(min-width: 768px)").matches) {
      valueToChangeHeaderStyle = 150;
    } else {
      valueToChangeHeaderStyle = screenHeight;
    }
  } else {
    valueToChangeHeaderStyle = 30;
  }
  if (scrollPosition > valueToChangeHeaderStyle) {
    header.classList.add('header--scrolled');
    header.querySelector('.header__logo').classList.add('active');
    header.querySelector('.header__logo-link').classList.add('active');
  } else {
    header.classList.remove('header--scrolled');
    header.querySelector('.header__logo').classList.remove('active');
    header.querySelector('.header__logo-link').classList.remove('active');
  }
}